// extracted by mini-css-extract-plugin
module.exports = {"AdSlotMail__mail":"bgu_a bhs_vf bhs_a bhs_q bhs_k","AdSlotMail__mail--notLoaded":"bgu_b bhs_eu bhs_bj bhs_vu","show-ad-not-loaded":"bgu_c","AdSlotMail__cta":"bgu_e"};